import React from 'react';

import { ProductsComponentProps } from 'common/types';
import { cartItemDetails } from 'modules/productsModule/utils';
import { useSelectedCartItems } from 'service/hooks';
import { usePersistedCartData } from 'common/hooks';
import { LAYOUT_THREE, URLS } from 'common/constants';
import { changeRoute } from 'common/utils';
import ProductCard from '../../../ProductCard';
import { StyledGroceryProductsContainer } from './style';

const GroceryProducts: React.FC<ProductsComponentProps> = ({ isLoading, products, isSearch }) => {
  const [cartData] = usePersistedCartData();
  const { data: selectedCartItems } = useSelectedCartItems({ ...cartData });

  if (isLoading) {
    return (
      <StyledGroceryProductsContainer>
        {Array.from([...Array(6)].keys()).map(num => (
          <ProductCard productLayout={LAYOUT_THREE} isLoading key={`sh-grocery-card-${num}`} />
        ))}
      </StyledGroceryProductsContainer>
    );
  }

  return (
    <StyledGroceryProductsContainer>
      {products.map((product, index) => {
        const { uuid } = product;
        const cartItem = cartItemDetails({ selectedCartItems, uuid });
        return (
          <ProductCard
            index={index}
            key={uuid}
            productLayout={LAYOUT_THREE}
            uuid={isSearch ? null : uuid}
            isLoading={isLoading}
            searchProduct={isSearch ? product : null}
            cartItem={cartItem}
            onClick={() =>
              changeRoute({
                pathname: URLS.PRODUCT_DETAILS,
                query: { id: uuid },
              })
            }
          />
        );
      })}
    </StyledGroceryProductsContainer>
  );
};

export default GroceryProducts;
